import { transport } from 'config/transport';

export function callApiSaveNumberOfNuns(congDoanId, year, body) {
    return transport.post(`/congdoan/${congDoanId}/nun/soluong`, body, { params: { year } });
}
